import React from 'react';
import axios from 'axios';
import { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function Bank(props) {
    const [inputField, setInputField] = useState({
        bank_name: '',
        acc_no: '',
        ifsc: '',
        acc_holder: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputField(prev => ({ ...prev, [name]: value }));
    };

    const fetchData = () => {
        fetch('https://singlewindowsecurities.com/rest3/user_details_api/' + localStorage.getItem('userid'))
            .then((response) => response.json())
            .then((data) => {
                setInputField({
                    bank_name: data.bank_name || '',
                    acc_holder: data.acc_holder || '',
                    ifsc: data.ifsc || '',
                    acc_no: data.acc_no || ''
                });
            });
    };

    useEffect(() => {
        fetchData();
    }, []);

    const formSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        
        const formData = new FormData();
        formData.append("bank_name", inputField.bank_name);
        formData.append("acc_no", inputField.acc_no);
        formData.append("ifsc", inputField.ifsc);
        formData.append("acc_holder", inputField.acc_holder);
        formData.append("id", localStorage.getItem('userid'));

        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };

        axios.post('https://singlewindowsecurities.com/rest3/web_bank_update_api', formData, config)
            .then((res) => {
                alert(res.data.msg);
                navigate('/settings');
            })
            .catch((err) => {
                alert("Could not update bank details");
                console.error(err);
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <div className="safearea" style={{ 
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0d0d0d 100%)'
        }}>
            <Helmet>
                <title>Bank Details | Single Window Securities</title>
            </Helmet>

            {/* Modern Header */}
            <div style={{
                background: 'rgba(10, 10, 10, 0.95)',
                backdropFilter: 'blur(10px)',
                borderBottom: '1px solid rgba(212, 175, 55, 0.3)',
                position: 'sticky',
                top: 0,
                zIndex: 100
            }}>
                <div className="container">
                    <div className="d-flex align-items-center py-3">
                        <Link to="/settings" className="btn me-2" style={{
                            background: 'rgba(212, 175, 55, 0.1)',
                            border: '1px solid rgba(212, 175, 55, 0.3)',
                            borderRadius: '12px',
                            width: '36px',
                            height: '36px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#D4AF37'
                        }}>
                            <i className="fa fa-arrow-left"></i>
                        </Link>
                        <h1 className="h5 mb-0 fw-bold" style={{ color: '#D4AF37' }}>Bank Details</h1>
                    </div>
                </div>
            </div>

            <main className="container py-4">
                <div style={{
                    background: 'rgba(20, 20, 20, 0.95)',
                    borderRadius: '24px',
                    border: '1px solid rgba(212, 175, 55, 0.2)',
                    overflow: 'hidden'
                }}>
                    <div className="p-4">
                        <form onSubmit={formSubmit}>
                            <div className="mb-4">
                                <label htmlFor="bank_name" className="form-label small fw-semibold mb-2" style={{ color: '#D4AF37', letterSpacing: '1px' }}>
                                    BANK NAME
                                </label>
                                <input
                                    type="text"
                                    id="bank_name"
                                    name="bank_name"
                                    value={inputField.bank_name}
                                    onChange={handleChange}
                                    className="form-control"
                                    style={{
                                        background: '#1a1a1a',
                                        border: '1px solid rgba(212, 175, 55, 0.3)',
                                        borderRadius: '12px',
                                        color: '#fff',
                                        padding: '12px'
                                    }}
                                    placeholder="Enter bank name"
                                    required
                                />
                            </div>

                            <div className="mb-4">
                                <label htmlFor="acc_holder" className="form-label small fw-semibold mb-2" style={{ color: '#D4AF37', letterSpacing: '1px' }}>
                                    ACCOUNT HOLDER NAME
                                </label>
                                <input
                                    type="text"
                                    id="acc_holder"
                                    name="acc_holder"
                                    value={inputField.acc_holder}
                                    onChange={handleChange}
                                    className="form-control"
                                    style={{
                                        background: '#1a1a1a',
                                        border: '1px solid rgba(212, 175, 55, 0.3)',
                                        borderRadius: '12px',
                                        color: '#fff',
                                        padding: '12px'
                                    }}
                                    placeholder="Enter account holder name"
                                    required
                                />
                            </div>

                            <div className="mb-4">
                                <label htmlFor="acc_no" className="form-label small fw-semibold mb-2" style={{ color: '#D4AF37', letterSpacing: '1px' }}>
                                    ACCOUNT NUMBER
                                </label>
                                <input
                                    type="text"
                                    id="acc_no"
                                    name="acc_no"
                                    value={inputField.acc_no}
                                    onChange={handleChange}
                                    className="form-control"
                                    style={{
                                        background: '#1a1a1a',
                                        border: '1px solid rgba(212, 175, 55, 0.3)',
                                        borderRadius: '12px',
                                        color: '#fff',
                                        padding: '12px'
                                    }}
                                    placeholder="Enter account number"
                                    required
                                />
                            </div>

                            <div className="mb-4">
                                <label htmlFor="ifsc" className="form-label small fw-semibold mb-2" style={{ color: '#D4AF37', letterSpacing: '1px' }}>
                                    IFSC CODE
                                </label>
                                <input
                                    type="text"
                                    id="ifsc"
                                    name="ifsc"
                                    value={inputField.ifsc}
                                    onChange={handleChange}
                                    className="form-control text-uppercase"
                                    style={{
                                        background: '#1a1a1a',
                                        border: '1px solid rgba(212, 175, 55, 0.3)',
                                        borderRadius: '12px',
                                        color: '#fff',
                                        padding: '12px'
                                    }}
                                    placeholder="Enter IFSC code"
                                    required
                                />
                            </div>

                            <button
                                type="submit"
                                className="btn w-100 py-3 mt-2 fw-bold"
                                disabled={isLoading}
                                style={{
                                    background: isLoading ? '#333' : 'linear-gradient(145deg, #D4AF37, #B8960C)',
                                    border: 'none',
                                    borderRadius: '16px',
                                    color: isLoading ? '#888' : '#000',
                                    fontWeight: 'bold',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                    if (!isLoading) {
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.boxShadow = '0 5px 20px rgba(212, 175, 55, 0.3)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = 'none';
                                }}
                            >
                                {isLoading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" style={{ color: '#D4AF37' }} aria-hidden="true"></span>
                                        Updating...
                                    </>
                                ) : (
                                    'Update Bank Details'
                                )}
                            </button>
                        </form>
                    </div>
                </div>

                {/* Info Note */}
                <div className="mt-3 text-center">
                    <small style={{ color: '#555' }}>
                        <i className="fas fa-lock me-1"></i>
                        Your bank details are securely encrypted
                    </small>
                </div>
            </main>

            <style>
                {`
                    input:focus {
                        box-shadow: 0 0 0 2px rgba(212, 175, 55, 0.3) !important;
                        outline: none;
                        border-color: #D4AF37 !important;
                    }
                    input::placeholder {
                        color: #666 !important;
                    }
                `}
            </style>
        </div>
    );
}